import { Common, ApiBind } from './common.model';

export class AdRequestRelation extends Common {

  @ApiBind({ column: 'id' })
  id: number;

  @ApiBind({ column: 'placement_id' })
  placementId: number;

  @ApiBind({ column: 'platform_id' })
  platformId: number;

  @ApiBind({ column: 'ad_format' })
  adFormat: number;

  @ApiBind({ column: 'ad_request_id' })
  adRequestId: number;
}
